<template>
    <Modal class="review-check-modal" @close="$emit('close')">
        <template v-slot:body>
            <div class="review-body">
                 <div class="icon">
                     <img src="@/assets/image/ico_pls_no.svg" v-if="values.value.replace(/ /gi, '').replace(/(?:\r\n|\r|\n)/g, '').length<5">
                     <img src="@/assets/image/ico_pls_yes.svg" v-else>
                </div>
                <div class="txt">
                    
                    <h5>{{lang.pls_MainMsg}}!</h5>
                    <small>{{lang.guide_mag_thank}}</small>
                </div>
                <div class="input">
                    <Textarea :txt="values" @realtime="inputReview"/>
                    <small>{{lang.review_notice}}</small>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <Button :btn="btnLabel" :isDisabled="btnDisabled" @btnClick="modalSubmit"/>
        </template>
    </Modal>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Modal from '@/components/slots/ModalFrame';

import Textarea from '@/components/forms/Textarea'
import Button from '@/components/forms/Button';

export default {
     name: 'ReviewCheckModal',
     props: ['lang', 'values'],
    components:{
        Textarea, Button,
        Modal
    },
    data(){
        return{
            inputs: '',
            ok: {
                label: this.lang.ok,
                className: 'default'
            },
            pass: {
                label: this.lang.pls_goBtn,
                className: 'default'
            }
        }
    },
    computed: {
        ...mapGetters(['getIsLoading']),

        btnDisabled(){
            const txtCount = this.values.value.replace(/ /gi, "").replace(/(?:\r\n|\r|\n)/g, '').length;
            return txtCount>0 && txtCount<5
        },

        btnLabel(){
            const txtCount = this.values.value.replace(/ /gi, "").replace(/(?:\r\n|\r|\n)/g, '').length;
            return txtCount===0?this.pass : this.ok
        }
    },
    methods: {
...mapActions(['setIsLoading']),
        inputReview(payload){
            this.$emit('realtime', payload)
        },

        modalSubmit(){

            this.setIsLoading(true);

            const txtCount = this.values.value.replace(/ /gi, "").replace(/(?:\r\n|\r|\n)/g, '').length;
            
            
            if(txtCount===0){
                this.$emit('modalInputs', {inputs: this.values.value.trim()});
            }else {
                if(txtCount>4){
                    this.$emit('modalInputs', {inputs: this.values.value.trim()});
                }else{
                    alert(this.lang.review_notice);
                    this.setIsLoading(false);
                }
            }
            

        }

    }
}
</script>

<style lang="scss" scoped>
.icon {
    @include size(56px, 56px);
    border-radius: 100%;
    position: relative;
    margin-bottom: 16px;
    
    img {
        @include transform;
        width: 56px;
    }
}

.review-check-modal{
    .review-body{
        display: flex;
        flex-direction: column;
        align-items: center;

        .txt{
            margin-bottom: 24px;
            *{
                text-align: center;
                line-height: 1.6em;
                display: block;
            }
            h5{
                color: $color-point;
            }
        }
            .input{
        small{
            color: $color-sub-txt;
        }
    }
    }

    button{
        width: 100%;
        height: 100%;
        border-radius: 0;
    }
}

</style>